module.exports = __webpack_public_path__ + "static/logo4bubble-7ea51f23e039111079a6fa9e738b02cb.svg";